import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchDashboardGroups } from '../redux/columnsSlice';
import UnifiedTable from './UnifiedTable';

function GestorDashboards({ unique_key }) {
  const dispatch = useDispatch();
  const isAdmin = !unique_key || unique_key.trim() === "";
  const { dashboardGroups, loadingDashboardGroups, errorDashboardGroups } = useSelector(
    (state) => state.columns
  );

  useEffect(() => {
    if (isAdmin) {
      dispatch(fetchDashboardGroups())
        .unwrap()
        .catch((err) => {
          console.error("[GestorDashboards] Error en fetchDashboardGroups:", err);
        });
    }
  }, [isAdmin, dispatch]);

  if (isAdmin) {
    return (
      <div className="autocrm-dashboard-container">
        <h2>Gestor de Dashboards (Admin)</h2>
        {loadingDashboardGroups && <p>Cargando grupos de dashboards...</p>}
        {errorDashboardGroups && <p style={{ color: 'red' }}>Error: {errorDashboardGroups}</p>}
        {!loadingDashboardGroups && dashboardGroups && dashboardGroups.length === 0 && (
          <p>No hay dashboards guardados.</p>
        )}
        {dashboardGroups && dashboardGroups.length > 0 && (
          <table className="autocrm-data-table">
            <thead>
              <tr>
                <th>Unique Key</th>
                <th>Grupo</th>
                <th>Columnas</th>
                <th>Shortcode</th>
              </tr>
            </thead>
            <tbody>
              {dashboardGroups.map((grp) => {
                const shortcode = `[mostrar_autocrm_dashboards unique_key="${grp.unique_key}"]`;
                const columnsText = grp.columns?.length
                  ? grp.columns
                      .filter((c) => c.column_name && c.column_name !== 'undefined')
                      .map((c) => c.column_name)
                      .join(', ')
                  : '(Sin columnas)';
                return (
                  <tr key={grp.unique_key}>
                    <td>{grp.unique_key}</td>
                    <td>{grp.group_name || 'N/A'}</td>
                    <td>{columnsText}</td>
                    <td>
                      <input
                        type="text"
                        value={shortcode}
                        readOnly
                        className="autocrm-shortcode-input"
                      />
                      <button onClick={() => {
                        navigator.clipboard.writeText(shortcode);
                      }}>
                        Copiar
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    );
  }

  return <UnifiedTable unique_key={unique_key} />;
}

export default GestorDashboards;
